<script type="text/ecmascript-6">
    import DesignerQuestionHardwareColour from "./DesignerQuestionHardwareColour.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareColour
        ],
        props: {
            sbd: {
                required: true,
            },
            hardwareSuite: {
                required: true,
            },
            title: {
                default() {
                    return 'Pick A Finish For Your Hardware';
                }
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/hardware-colour?slab=' + this.slab + '&secured_by_design=' + this.sbd + '&hardware_suite=' + this.hardwareSuite + '&opening_direction=' + this.openingDirection + '&door_range=' + this.doorRange + '&profile=' + this.profile;
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.sbd, this.hardwareSuite, this.openingDirection, this.doorRange, this.profile);
            },
            filtered_option_list(){
                if (this.option_list === null) {
                    return [];
                }

                if (!Array.isArray(this.option_list)) {
                    return [];
                }

                return this.option_list.filter((key)=> {
                    return key.value !== null && !!key.value;
                });
            },
            cache_key(){
                return '_' + this.slab + '_' + this.sbd + '_' + this.hardwareSuite + '_' + this.openingDirection + '_' + this.doorRange + '_' + this.profile;
            },
        },
        watch: {
            'sbd': function (val, oldVal) {
                this.update_options();
            },
            'hardwareSuite': function (val, oldVal) {
                this.update_options();
            }
        },
    }
</script>
